import { useDeletePbxMutation } from "../pbxApi";
import { IconButton } from "@8x8/oxygen-icon-button";
import { TrashIcon } from "@8x8/oxygen-icon/icons";
import { DURATION, notify, TYPE } from "@8x8/oxygen-toaster";
import { errorNotification, useErrorNotification } from "@/react/notifications";

const DeleteActionCell = ({ row }) => {
  const [deletePbx, { error }] = useDeletePbxMutation();

  useErrorNotification(error);

  const confirmDeleteAction = (pbxName) => {
    const toast = notify({
      content: `Are you sure you want to delete PBX ${pbxName}?`,
      duration: DURATION.INFINITE,
      type: TYPE.warning,
      hideCloseControl: true,
      actions: [
        {
          title: "Yes",
          callback: () => {
            toast.close();
            handleDelete();
          },
          id: "confirm",
        },
        {
          title: "No",
          callback: () => {
            toast.close();
          },
          id: "infer",
        },
      ],
    });
  };

  const handleDelete = () => {
    deletePbx(row.original.pbxId)
      .unwrap()
      .then(() =>
        notify({
          type: TYPE.success,
          content: `PBX ${row.original.name} successfully deleted!`,
          duration: 5000,
        })
      )
      .catch(errorNotification);
  };

  if (!row.original.pbxId) return null;

  return (
    <IconButton onClick={() => confirmDeleteAction(row?.original?.name)}>
      <TrashIcon />
    </IconButton>
  );
};

export default DeleteActionCell;
